import { render, staticRenderFns } from "./SearchBox.vue?vue&type=template&id=5557c72b&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"
import style0 from "./SearchBox.vue?vue&type=style&index=0&id=5557c72b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5557c72b",
  null
  
)

export default component.exports